import { cn } from "@/lib/utils";
import {
  EmergencyBellBadge,
  EmergencyHighlightPulse,
} from "@/pages/roster-create/components/shift-code/emergency-code";

type EmergencyBulkRangeBarProps = {
  /** 바의 가로 셀 개수 (1 = 단일 셀, N = N칸 너비) */
  rangeLength: number;
  /** 범위 완성 여부: false이면 시작만 선택된 점선 표시 */
  isComplete: boolean;
};

/**
 * 기간 지정 모드에서 테이블 셀에 렌더되는 선택 범위 바.
 * 당일 긴급 슬롯(`EmergencyCode`)과 동일한 빨간 테두리·펄스·벨만 가로로만 늘린 형태.
 * 시작 셀에서만 렌더한다.
 */
export default function EmergencyBulkRangeBar({
  rangeLength,
  isComplete,
}: EmergencyBulkRangeBarProps) {
  return (
    <div
      className={cn(
        "emergency-bulk-range-bar",
        "absolute top-1/2 z-10 pointer-events-none -translate-y-1/2 left-[2px] rounded-sm border-3 bg-transparent",
        "animate-in fade-in duration-200",
        isComplete
          ? "border-red-600"
          : "border-red-500 border-dashed",
        rangeLength === 1 ? "size-7.5" : "h-7.5"
      )}
      style={{
        willChange: "opacity, transform",
        ...(rangeLength > 1
          ? { width: `calc(${rangeLength} * 100% - 4px)` }
          : {}),
      }}
    >
      <EmergencyHighlightPulse />
      <EmergencyBellBadge />
    </div>
  );
}
